import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Observer from '@researchgate/react-intersection-observer'
import isEqual from 'react-fast-compare'

function withSnapPoint(WrappedSlide, className, onVisibilityChange) {
  return class ViewableMonitor extends Component {

    constructor(props) {
      super(props)
      this.rendered = false
      this.slideRef = React.createRef()

      // Google Tag Manager: Slide Identifier
      this.trackingId = `slide_${props.index}_${props.slideType || 'unknown'}`
    }

    componentDidMount() {
      const { index, createSnapPoint } = this.props
      createSnapPoint(index, this.slideRef)
    }

    handleChange = ({ isIntersecting }) => {
      const {
        index,
        slideType,
        onVisibilityChange: defaultVisibilityChage
      } = this.props

      /*
        Fix bug in Firefox that means all elements return true for their first
        render and hence cause rendering + callback loops that lead to massive
        memory leaks. Bugfix is basically ignoring the intial 'I am visible' event.
      */
      if (this.rendered == false) {
        this.rendered = true
        return
      }

      // Update snapping slider with current slide
      const onChange = onVisibilityChange || defaultVisibilityChage
      if (onChange) {
        onChange(isIntersecting, index, slideType)
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      const { index, currentSlide } = this.props
      const { currentSlide: nextCurrentSlide } = nextProps

      /*
        Logic that means only two slides (the new active and previous active slide) will update when the currentSlide
        variable changes instead of all the slides. Reduces renders and makes scroller faster!
      */
      if(nextCurrentSlide != index && currentSlide != index ) {
        return false
      }

      return !isEqual(nextProps, this.props)
    }

    render() {
      const {
        parentRef,
        currentSlide,
        containerClassName,
        createSnapPoint,
        slideType,
        slideThreshold,
        ...rest
      } = this.props

      return (
        <Observer root={parentRef.current} onChange={this.handleChange} threshold={slideThreshold}>
          <section
            data-tracking-id={this.trackingId}
            className={[containerClassName, className].join(' ')}
          >
            <WrappedSlide
              {...this.props}
              slideRef={this.slideRef}
              active={currentSlide == rest.index}
            />
          </section>
        </Observer>
      );
    }
  }
}

export default withSnapPoint
